var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.212,
    height: 10.728,
    viewBox: "0 0 33.212 10.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4803",
    "data-name": "Rectangle 4803",
    width: 33.212,
    height: 10.727,
    transform: "translate(639.5 741.5)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa_logo",
    "data-name": "visa logo",
    transform: "translate(-639.5 -741.5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36443",
    "data-name": "Path 36443",
    d: "M653.9,752.074h-2.686l1.68-10.385h2.685Z",
    fill: "#00579f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36444",
    "data-name": "Path 36444",
    d: "M663.629,741.942a6.614,6.614,0,0,0-2.408-.442c-2.652,0-4.519,1.414-4.53,3.436-.022,1.491,1.337,2.319,2.353,2.817,1.039.508,1.392.84,1.392,1.293-.011.7-.84,1.016-1.613,1.016a5.344,5.344,0,0,1-2.519-.552l-.354-.166-.375,2.331a8.164,8.164,0,0,0,2.994.552c2.818,0,4.652-1.392,4.674-3.546.01-1.182-.707-2.088-2.254-2.828-.939-.475-1.514-.8-1.514-1.282.011-.442.486-.894,1.546-.894a4.551,4.551,0,0,1,2,.4l.243.111Z",
    fill: "#00579f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36445",
    "data-name": "Path 36445",
    d: "M667.2,748.4c.221-.6,1.072-2.905,1.072-2.905-.011.022.221-.608.354-.995l.187.9s.509,2.486.619,3.005Zm3.315-6.706h-2.077a1.326,1.326,0,0,0-1.4.862l-3.988,9.523h2.817l.564-1.558h3.447c.077.365.321,1.558.321,1.558h2.486Z",
    fill: "#00579f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36446",
    "data-name": "Path 36446",
    d: "M648.968,741.689l-2.63,7.082-.287-1.436a7.944,7.944,0,0,0-3.713-4.353l2.409,9.081h2.839l4.221-10.374Z",
    fill: "#00579f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36447",
    "data-name": "Path 36447",
    d: "M643.9,741.689h-4.32l-.044.21a8.985,8.985,0,0,1,6.519,5.436l-.939-4.773A1.112,1.112,0,0,0,643.9,741.689Z",
    fill: "#faa61a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentVisa);
export default __webpack_public_path__ + "static/media/paymentVisa.f9ac22b34efb7a51472efb6ad1ab48cd.svg";
export { ForwardRef as ReactComponent };